module.exports = "<div class=\"c-loginout\" ng-class=\"{'c-loginout--allowed': $ctrl.isLoginAllowed(), 'c-loginout--logged-in': $ctrl.isLoggedIn()}\">\n    <button class=\"c-loginout__action c-login / t-text--secondary--action\" ng-click=\"$ctrl.login()\">Log in</button>\n    <button class=\"c-loginout__action c-logout / t-text--secondary--action\" ng-click=\"$ctrl.logout()\">Log out\n        <span class=\"c-logout__tooltip\">Logged in as: {{ $ctrl.storeService.get('client_name') }}</span>\n    </button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/widget/views/logInOut.html
// module id = 791
// module chunks = 0